import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Input from '../../../../../../../common/ui/Input/input';
import {
  Body, BodyContainer, InputBox, KeyboardContainer, NextButton,
} from '../../../utils/style';
import Keyboard from '../../common/keyboard';
import { resetTicket } from '../../../../store/actions';
import Store from '../../../../store/store';
import {
  onlyDigits, formatNationalPhone, isPhoneComplete, toClientPhone,
} from './phone';

const { dispatch } = Store;

function PhonePhoneInput({ children }) {
  const { style, config } = useSelector((state) => state);
  const { id, headUrl } = config;
  const [phone, setPhone] = useState('');
  const [inputId, setId] = useState('input');
  const { title, button, input } = style;
  const navigate = useNavigate();

  const item = {
    name: '',
    params: {
      fid: 'input',
      value: 'number',
    },
  };

  const clickInput = (value) => setId(value);

  const onNext = () => {
    const data = {
      zone_id: config.idZone,
      clientPhone: toClientPhone(phone),
      satellite_id: config.id,
    };
    dispatch(resetTicket(data));
    navigate(`${headUrl}/${id}/phonePrint`);
  };

  return (
    <BodyContainer style={style.body}>
      <Body>
        <div style={title}>Введите телефон</div>
        <KeyboardContainer height>
          <InputBox button={button} style={{ flex: 0, margin: '30px 0' }}>
            <Input
              item={item}
              height={70}
              style={input}
              width="50%"
              value={formatNationalPhone(phone)}
              id={inputId}
              clickInput={clickInput}
            />
          </InputBox>
          <Keyboard
            styleButton={button}
            setValue={(e) => setPhone(onlyDigits(e).slice(0, 10))}
            value={phone}
            id={inputId}
          />
        </KeyboardContainer>
        {isPhoneComplete(phone) && (
          <NextButton
            style={{
              ...style.bottomButton,
            }}
            onClick={onNext}
          >
            Готово
          </NextButton>
        )}
      </Body>
      {children}
    </BodyContainer>
  );
}

export default PhonePhoneInput;
